import React, { useEffect } from 'react';
import GooglePayButton from '@google-pay/button-react';

interface GpayIframeButtonProps {
    apiData: any;
    onPaymentSuccess: (paymentData: any) => void;
}



const GpayIframeButton: React.FC<GpayIframeButtonProps> = ({ apiData, onPaymentSuccess }) => {
    useEffect(() => {
        console.log("apiData", process.env.REACT_APP_PUBLIC_GOOGLE_PAY_ENVIRONMENT);
    }, [apiData]);
    return (
        <div style={{ width: apiData?.pspConfig?.width || 480, height: apiData?.pspConfig?.height || 30 }}>
            <GooglePayButton
                environment={(process.env.REACT_APP_PUBLIC_GOOGLE_PAY_ENVIRONMENT || "TEST") as "TEST" | "PRODUCTION"}
                paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [{
                        type: 'CARD',
                        parameters: {
                            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                            allowedCardNetworks: apiData?.pspConfig?.merchantCards
                        },
                        tokenizationSpecification: {
                            type: 'PAYMENT_GATEWAY',
                            parameters: {
                                gateway: apiData?.pspConfig?.gatewayName.toLowerCase(),
                                gatewayMerchantId: apiData?.pspConfig?.gatewayMerchantId
                            }
                        }
                    }],
                    merchantInfo: {
                        merchantId: apiData?.pspConfig?.merchantId,
                        merchantName: apiData?.pspConfig?.merchantName
                    },
                    transactionInfo: {
                        totalPriceStatus: 'FINAL',
                        totalPrice: apiData?.transactionInfo?.totalPrice,
                        currencyCode: apiData?.pspConfig?.currencyCode,
                        countryCode: apiData?.pspConfig?.countryCode || 'US'
                    }
                }}
                onLoadPaymentData={onPaymentSuccess}
                buttonType="plain"
                style={{ width:apiData?.pspConfig?.width || 480, height:apiData?.pspConfig?.height || 30 }}
                buttonSizeMode="fill"
            />
        </div>
    );
};

export default GpayIframeButton; 